<div class="custom-security-link">
    <a [routerLink]="['/marketing/view']">My Mailings</a>
    <a [routerLink]="['/email-blast']">Create New Email Blast</a>
    <a [routerLink]="['/direct-mail']">Create New Direct Mail Mailing</a>
</div>
<div class="margin-all-area">
    <div class="wraper-main-section">
        <div class="global-card-section">
            <div class="global-header-section">
                <div class="svg-icon-panel">
                    <div *ngIf="type == 2 && mailingData?.subject != ''"><img src="../../../../assets/emailtitle.svg" class="mr-1" />Email Campaign : {{mailingData?.subject}}</div>
                    <div *ngIf="type == 1 && mailingData?.subject != ''"><img src="../../../../assets/mailingtitle.svg" class="mr-1" />Mailing Campaign : {{mailingData?.subject}}</div>
                    <div *ngIf="type == 6 && mailingData?.subject != ''"><img src="../../../../assets/txtmsgstitle.svg" class="mr-1" />Text Campaign:  {{mailingData?.subject}}</div>
                    <div *ngIf="type == 7 && mailingData?.subject != ''"><img src="../../../../assets/activity/voice/voicerecordtitle.svg" class="mr-1" />Voice Drop Campaign: {{mailingData?.subject}}</div>
                </div>
                <div class="header-button-panel">
                    <div class="button-wrapper">
                        <contact-common-search (totalContactCount)="setTotalContactCount($event)" (contactSearchDisplay)="setContactSearchDisplay($event)" (isRunSearch)="isRunSearch($event)" [marketingType]="marketingType" [emailType]="emailType"></contact-common-search>
                        <button type="button" matTooltip="Cancel Edit" class="icon-btn" (click)="editMailing();">
                            <img src="../../../../assets/cancel.svg" />
                            <span class="btn-text">Back</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="message-info" *ngIf="mailingData?.status == 2">This mailing has already been completed and can no longer be edited..</div>
            <div class="message-info" *ngIf="mailingData?.status != 2">Setup the new search criteria and click <i>Save</i>.</div>
            <div>
                <div class="wraper-body-panel">
                    <div class="wraper-body-left">
                        <div class="cards-body-section">
                            <div class="cards-colunm-left"><span>Search Criteria</span></div>
                            <div class="cards-colunm-right" [innerHTML]="currentRecipientSummary?.strSearchCriteria">
                            </div>
                        </div>
                        <div class="cards-body-section">
                            <div class="cards-colunm-left"><span>Estimated Recipients</span></div>
                            <div class="cards-colunm-right">
                                <span>
                                    {{currentRecipientSummary?.strEstimatedRecipients}}
                                </span>
                            </div>
                        </div>
                        <div class="cards-body-section">
                            <div class="cards-colunm-left"><span>New Search Criteria</span></div>
                            <div class="cards-colunm-right">
                                <div>
                                    <div *ngIf="strcontactSearchDisplay">
                                        <span style="color:black" [innerHtml]="strcontactSearchDisplay | safeHtml"></span>
                                    </div>
                                    <div *ngIf="contactsData?.length > 0" class="button-wrapper">
                                        <button class="btn btn-primary" (click)="updateQuery()">Update Search</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="contactsData?.length > 0" class="mailing-mat-grid">
            <div class="message-info">Total Contact Found: {{totalContactCount}}</div>
            <table mat-table [dataSource]="contactListSource" class="mat-elevation-z8" matSort (matSortChange)="_localService.setSortState($event, 'contact_map_grid')">
                <ng-container *ngFor="let column of columns" [matColumnDef]="column.field">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ column.title }} </th>
                    <td mat-cell *matCellDef="let dataItem; let i = index">
                        <div class="customer-name" *ngIf="column.field == '$'">{{ getSerialNumber(i) }}</div>
                        <div class="customer-name" *ngIf="column.field == '$$'"><a class="grid-icon" [attr.href]="gotoLink($event, 'name', dataItem)" title="View Contact"><img src="../../../assets/icon_contact.svg" /></a></div>
                        <div class="customer-name" *ngIf="column.field == 'email'"><a class="grid-icon" (click)="gotoLink($event, 'email', dataItem);" title="send email to {{dataItem.email}}" *ngIf="dataItem.email"><i class="email_new"><img src="../../../assets/email_new.svg" /></i></a></div>
                        <div class="customer-name" *ngIf="column.field == 'text'"><a class="grid-icon" (click)="showTextMail(dataItem?.contactID);" title="{{dataItem?.mobile | phoneFormat}}" *ngIf="dataItem.mobile !=''"><i class="email_new"><img src="../../../../assets/txtmsgstitle_grey.svg" /></i></a></div>
                        <div class="customer-name" *ngIf="column.field == 'phone'"><a class="contact-cursor-pointer" data-toggle="modal" data-target="#newCallCreateModal" title="Make Call" (click)="openModalNewCall(dataItem,'mp')"> <span [innerHTML]="dataItem[column.field] ? dataItem[column.field] : '--'"></span></a></div>
                        <div class="customer-name" [ngClass]="[column.field=='name' ? 'text-left' : '',  column.field=='companyName' ? 'text-left' : '']" *ngIf="showColumn(column.field)" [hidden]="column.field=='$' || column.field=='$$'">
                            <a class="webkit-any-link" [attr.href]="onCompanySelect(dataItem.coCompanyID)" title="{{dataItem[column.field]}}" [style.color]="column.field == 'coCompanyName'? '#1c0dbf':''" *ngIf="column.field == 'companyName'">{{dataItem[column.field] ? dataItem[column.field] : ''}}</a>
                            <a class="webkit-any-link" [attr.href]="gotoLink($event, column.field, dataItem)" [style.color]="column.field == 'userName'? '#1c0dbf':''" *ngIf="column.field == 'name' || column.field == 'userName'">{{dataItem[column.field] ? dataItem[column.field] : '--'}}</a>
                            <span [hidden]="column.field == 'name' || column.field == 'userName' || column.field == 'text' || column.field == 'dtModifiedDisplay' || column.field == 'dtCreatedDisplay' || column.field == 'companyName' || column.field == 'address'">{{dataItem[column.field] ? dataItem[column.field] : '--'}}</span>
                            <span *ngIf="column.field == 'dtModifiedDisplay' || column.field == 'dtCreatedDisplay'">{{ !dataItem[column.field] ? '--' : dataItem[column.field] | date: dateFormat }}</span>
                        </div>
                        <div class="customer-name" *ngIf="column.field == 'address'"><span>{{dataItem[column.field]}}</span><br /><span>{{dataItem['city']}}</span><br /><span>{{dataItem['country']}}</span></div>

                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="contactListDisplayColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: contactListDisplayColumns;"></tr>
            </table>
            <mat-paginator *ngIf="contactsData?.length > 0" [pageSize]="pageSize" (page)="_localService.setPageSize($event, 'contact_map_grid')"
                           (page)="onPageChange($event)" [length]="contactsData?.length" [pageSizeOptions]="[10, 50, 100,200]"></mat-paginator>
        </div>
    </div>
</div>



<div class="modal fade" id="sendEmail" tabindex="-1" role="dialog" aria-labelledby="sendEmailLabel" aria-hidden="true" data-focus="false">
    <div class="custom-modal-panel" role="document">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content user-body-section border-radius-contact">
                <div class="modal-body">
                    <app-contact-email *ngIf="sendMailInfo?.isShow" [loggedUser]="user" (closeEmailModal)="hideSendMail()" [contactId]="sendMailInfo?.contactId"></app-contact-email>
                </div>
            </div>
        </div>
    </div>
</div>





<div class="modal fade" id="timezoneModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="custom-modal-panel" role="document">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content user-body-section border-radius-contact">
                <div class="modal-header user-body-header">
                    <h5 class="modal-title white-contact" id="exampleModalLabel">Timezone</h5>
                    <div class="button-wrapper">
                        <button type="button" class="icon-btn" data-dismiss="modal" aria-label="Close">
                            <i class="fas fa-times"></i>
                            <span class="btn-text">Close</span>
                        </button>
                    </div>
                </div>
                <div class="modal-body">
                    <h3>First, Please select your timezone.!!!</h3>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal" [routerLink]="['/edit-profile', user?.cLPUserID]">Ok</button>
                    <button type="button" class="btn btn-cancel" data-dismiss="modal">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="modal fade" id="newCallCreateModal" tabindex="-1" role="dialog" aria-labelledby="newCallCreateModalLabel" aria-hidden="true" data-focus="false">
    <div class="custom-modal-panel" role="document">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content user-body-section border-radius-contact">
                <div class="modal-header user-body-header">
                    <h5 class="modal-title white-contact" id="exampleModalLabel"><img src="../../../../../assets/btnVoiceCall.svg" class="" />Voice Call</h5>
                    <div class="button-wrapper">
                        <button type="button" class="icon-btn" data-dismiss="modal" aria-label="Close" (click)="isShowNewCallModal=false;">
                            <i class="fa fa-close"></i>
                            <span class="btn-text">Cancel</span>
                        </button>
                    </div>
                </div>
                <div class="modal-body">
                    <contact-new-call *ngIf="isShowNewCallModal && selectedContactData" [contactData]="selectedContactData" (updatedCall)="hideTextCallModal($event)" [callType]="selectedCallType" [user]="user"></contact-new-call>
                </div>
            </div>
        </div>

    </div>
</div>

